import * as $ from 'jquery';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import 'bootstrap-datepicker/js/locales/bootstrap-datepicker.pt-BR.js'
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';

export default (function () {

    window.datepickerOptions = {
        zIndexOffset: 1000,
        todayHighlight: true,
        todayBtn: true,
        language: 'pt-BR',
    };

    $('.datepicker').datepicker(window.datepickerOptions)

}())
